import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function R1() {
    const { useLang, Link, useRouter, useState } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const [activeIndex, setActiveIndex] = useState(0);

    const renderLink = (href: string) => (text: string) => (
        <Link href={href} className="oc-faq__link">
            {text}
        </Link>
    );

    const lists: any = [
        {
            title: t('secR_q1'),
            desc: t.rich('secR_a1', {
                a1: renderLink(t('secR_a1_link1')),
            }),
        },
        {
            title: t('secR_q2'),
            desc: t.rich('secR_a2', {
                a1: renderLink(
                    ['nl']?.includes(locale) ? t('secR2_a1_link1') : `https://blog.ecoflow.com/${locale}/how-many-solar-panels-do-you-need-for-rv/`,
                ),
                a2: renderLink(['nl']?.includes(locale) ? t('secR2_a1_link2') : `https://${locale}.ecoflow.com/pages/solar-panels`),
                l1: renderLink(t('secR_a2_link1')),
                l2: renderLink(t('secR_a2_link2')),
            }),
        },
        {
            title: t('secR_q3'),
            desc: t.rich('secR_a3', {
                a1: renderLink(t('secR_a3_link1')),
            }),
        },
        {
            title: t('secR_q4'),
            desc: t.rich('secR_a4', {
                a1: renderLink(t('secR_a4_link1')),
            }),
        },
        {
            title: t('secR_q5'),
            desc: t.rich('secR_a5', {
                a1: renderLink(`https://${locale}.ecoflow.com/products/delta-pro-portable-power-station`),
                a2: renderLink(`https://${locale}.ecoflow.com/pages/off-grid-solar-system`),
            }),
        },
        {
            title: t('secR_q6'),
            desc: t.rich('secR_a6', {
                a1: renderLink(`https://blog.ecoflow.com/${locale}/how-to-prepare-for-full-time-rv-living/`),
            }),
        },
        {
            title: t('secR_q7'),
            desc: t('secR_a7'),
        },
    ];

    if (['uk', 'eu', 'it', 'es', 'kr', 'nl'].includes(locale)) {
        lists?.pop();
    }

    const handleToggle = (index: number) => {
        setActiveIndex(activeIndex === index ? -1 : index);
    };

    return (
        <div id="vanlife-roadtrips-R" className={`vanlife-roadtrips-R1 ${css['vanlife-roadtrips-R1']}`}>
            <div className="oc-faq">
                <div className="oc-faq__content">
                    <div className="oc-faq__header">
                        <p className="oc-faq__title">{t('secR_title')}</p>
                    </div>
                    <div className="oc-faq__list">
                        {lists?.map((list: any, k: number) => {
                            const isActive = activeIndex === k;

                            return (
                                <div className={`oc-faq__item ${isActive ? 'oc-faq__item--active' : ''}`} key={k}>
                                    <button
                                        type="button"
                                        className="oc-faq__trigger"
                                        aria-expanded={isActive}
                                        onClick={() => handleToggle(k)}
                                    >
                                        <span className="oc-faq__question">{list.title}</span>
                                        <svg
                                            className={`oc-faq__icon ${isActive ? 'oc-faq__icon--active' : ''}`}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M12 13.6798L7.23755 8.96051C7.06255 8.7871 6.85005 8.70039 6.60005 8.70039C6.35005 8.70039 6.13755 8.7871 5.96255 8.96051C5.78755 9.13393 5.70005 9.3445 5.70005 9.59223C5.70005 9.83996 5.78755 10.0505 5.96255 10.2239L11.4 15.6121C11.8001 16.0085 12.2125 15.9961 12.6376 15.575L18.0376 10.2239C18.2126 10.0505 18.3 9.83996 18.3 9.59223C18.3 9.3445 18.2126 9.13393 18.0376 8.96051C17.8625 8.7871 17.6501 8.70039 17.4 8.70039C17.15 8.70039 16.9375 8.7871 16.7625 8.96051L12 13.6798Z"
                                                fill="#83868A"
                                            />
                                        </svg>
                                    </button>
                                    <div className={`oc-faq__panel ${isActive ? 'oc-faq__panel--open' : ''}`}>
                                        <div className="oc-faq__panel-inner">
                                            <p className="oc-faq__answer">{list.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
